export enum applicationCompanyTypes {
  FETCH_APPLICATION_COMPANY_REQUEST = "FETCH_APPLICATION_COMPANY_REQUEST",
  FETCH_APPLICATION_COMPANY_SUCCESS = "FETCH_APPLICATION_COMPANY_SUCCESS",
  FETCH_APPLICATION_COMPANY_FAILURE = "FETCH_APPLICATION_COMPANY_FAILURE",
}